// Change when the wordmark or a card's design changes so external image caches request the new design.
// D2: the /use-with-ai chat card.
export const WORDMARK_VERSION = "D2"
